import React, { useState } from 'react';
import '../../App.css';
import { PatientServiceCreation } from './PatientServiceCreation';
import { PatientServiceListExpanded } from './PatientServiceListExpanded';
import { PatientSignup } from './PatientSignup'; // Assuming this is the correct import
import { PatientSidebar } from '../../components/PatientSidebar';

function PatientDashboard() {
  const [activeComponent, setActiveComponent] = useState('request');

  const handleSidebarClick = (componentName) => {
    setActiveComponent(componentName);
  };

  const renderActiveComponent = () => {
    switch (activeComponent) {
      case 'request':
        return <PatientServiceCreation />;
      case 'details':
        return <PatientServiceListExpanded />;
      case 'profile':
        return <PatientSignup />;
      default:
        return <PatientServiceCreation />; // default page
    }
  };

  return (
    <div className="flex flex-row justify-center items-start">
      
        <PatientSidebar onSidebarClick={handleSidebarClick} />
      
      <div className="flex-grow p-6 shadow-lg">
        {renderActiveComponent()}
      </div>
    </div>
  );
}

export default PatientDashboard;
